import _ from 'lodash';

const validationRules = (value, confirmValue, rules) => {
    let isValid = true;
    let brokenRule = [];

    for (let rule in rules) {
        switch (rule) {
            case 'isAlphaNumeric':
                isValid = isValid && alphaNumericValidator(value);
                if (!isValid) brokenRule.push('isAlphaNumeric');
                break;
            case 'isBasSerialNumber':
                isValid = isValid && basSerialNumberValidator(value);
                if (!isValid) brokenRule.push('isBasSerialNumber');
                break;
            case 'isChecked':
                isValid = isValid && checkedValidator(value);
                if (!isValid) brokenRule.push('isChecked');
                break;
            case 'isClientId':
                isValid = isValid && clientIdValidator(value);
                if (!isValid) brokenRule.push('isClientId');
                break;
            case 'isClientSecret':
                isValid = isValid && clientSecretValidator(value);
                if (!isValid) brokenRule.push('isClientSecret');
                break;
            case 'isCompared':
                isValid = isValid && compareValidator(confirmValue);
                if (!isValid) brokenRule.push('isCompared');
                break;
            case 'isEmail':
                isValid = isValid && emailValidator(value);
                if (!isValid) brokenRule.push('isEmail');
                break;
            case 'isIpAddress':
                isValid = isValid && ipAddressValidator(value);
                if (!isValid) brokenRule.push('isIpAddress');
                break;
            case 'isNonemptyArray':
                isValid = isValid && nonemptyArrayValidator(value);
                if (!isValid) brokenRule.push('isNonemptyArray');
                break;
            case 'isNumeric':
                isValid = isValid && numberValidator(value);
                if (!isValid) brokenRule.push('isNumeric');
                break;
            case 'isPassword':
                isValid = isValid && passwordValidator(value);
                if (!isValid) brokenRule.push('isPassword');
                break;
            case 'isPhoneNumber':
                isValid = isValid && phoneNumberValidator(value);
                if (!isValid) brokenRule.push('isPhoneNumber');
                break;
            case 'isRequired':
                isValid = isValid && requiredValidator(value);
                if (!isValid) brokenRule.push('isRequired');
                break;
            case 'matches':
                isValid = isValid && matchesValidator(value, confirmValue);
                if (!isValid) brokenRule.push('matches');
                break;
            case 'maxLength':
                isValid = isValid && maxLengthValidator(value, rules[rule]);
                if (!isValid) brokenRule.push('maxLength');
                break;
            case 'maxValue':
                isValid = isValid && maxValueValidator(value, rules[rule]);
                if (!isValid) brokenRule.push('maxValue');
                break;
            case 'minLength':
                isValid = isValid && minLengthValidator(value, rules[rule]);
                if (!isValid) brokenRule.push('minLength');
                break;
            case 'minValue':
                isValid = isValid && minValueValidator(value, rules[rule]);
                if (!isValid) brokenRule.push('minValue');
                break;
            default:
                isValid = true;
                break;
        }
    }

    return {isValid, brokenRule};
};


/**
 * Verify minimum length
 *
 * @param value
 * @param minLength
 * @return
 */
const minLengthValidator = (value, minLength) => {
    return value.length >= minLength;
};

/**
 * Verify minimum value
 *
 * @param value
 * @param maxValue
 * @return
 */
const minValueValidator = (value, minValue) => {
    return Number(value) >= Number(minValue);
};

/**
 * Verify maximum length
 *
 * @param value
 * @param maxLength
 * @return
 */
const maxLengthValidator = (value, maxLength) => {
    return value.length <= maxLength;
};

/**
 * Verify maximum value
 *
 * @param value
 * @param maxValue
 * @return
 */
const maxValueValidator = (value, maxValue) => {
    return Number(value) <= Number(maxValue);
};

/**
 * Verify field is populated
 *
 * @param value
 * @return
 */
const requiredValidator = value => {
    /*
    if (typeof value === 'string') {
        return value.trim() !== '';
    } else {
        return value.length > 0;
    }
    */
    return value.trim() !== '';
};

/**
 * Verify array field has positive length
 *
 * @param {any} value
 * @return
 */
const nonemptyArrayValidator = value =>
{
    return value !== null && value.length > 0;
};

/**
 * Verify checkbox is clicked on
 *
 * @param value
 * @return
 */
const checkedValidator = value => {
    return value;
};

/**
 * Verify email address formatting
 *
 * @param value
 * @return
 */
const emailValidator = value => {
    var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(String(value).toLowerCase());
};

/**
 * Verify two values match
 *
 * @param value
 * @param confirmValue
 * @return
 */
const matchesValidator = (value, confirmValue) => {
    return String(value) === String(confirmValue);
};

/**
 * Verify end value is greater than start value, requires a "startValue" and
 * "endValue" in the model.
 *
 * @param confirmValue
 * @return
 */
const compareValidator = ({startValue, endValue}) => {
    return Number(startValue) < Number(endValue);
};

/**
 * Verify string is alpha numeric with one allowed space
 * (empty values also allowed)
 *
 * @param value
 * @return
 */
const alphaNumericValidator = value => {
    if (_.isEmpty(value)) return true;

    var re = /^[a-zA-Z0-9]+[\s]?[a-zA-Z0-9]*$/;
    return re.test(String(value).toLowerCase());
};

/**
 * Verify string is a valid US phone number
 *
 * @param value
 * @return
 */
const phoneNumberValidator = value => {
    if (_.isEmpty(value)) return true;

    var re = /^(\+1)?([2-9]{1})(\d{2})([2-9]{1})(?!11)(\d{2})(\d{4})$/;
    return re.test(String(value));
};

/**
 * Verify string is a valid password
 *
 * @param value
 * @return
 */
const passwordValidator = value => {
    if (value.length < 8 || value.length > 128) return false;

    if (/[\s\t\n\r]/.test(value)) return false;

    const upperCaseFilter = /[A-Z]/;
    const lowerCaseFilter = /[a-z]/;
    const numberFilter = /\d/;
    const specialCharacterFilter = /[\W_]/;

    return upperCaseFilter.test(value) &&
           lowerCaseFilter.test(value) &&
           numberFilter.test(value) &&
           specialCharacterFilter.test(value);
};

/**
 * Verify string matches Service Channel Id format requirements
 *
 * @param value
 * @return
 */
const clientIdValidator = value => {
    var re = /^PR\.[0-9]{10}\.[0-9A-Z]{8}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{12}$/g;
    return re.test(String(value));
};

/**
 * Verify string matches Service Channel Secret format requirements
 *
 * @param value
 * @return
 */
const clientSecretValidator = value => {
    var re = /^[0-9A-Z]{8}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{12}$/g;
    return re.test(String(value));
};

/**
 * Verify string matches BAS Serial Number format requirements
 *
 * @param value
 * @return
 */
const basSerialNumberValidator = value => {
    if (_.isEmpty(value)) {
        return true;
    }

    var re = /^[SH][2-9A-Z]{4}-[2-9A-Z]{5}-[2-9A-Z]{5}-[2-9A-Z]{5}-[2-9A-Z]{5}$/g;
    return re.test(String(value));
};

/**
 * Verify value is a number.
 *
 * @param value
 * @return
 */
const numberValidator = value => {
    var re = /^[0-9]+$/g;
    return re.test(Number(value));
};

/**
 * Verify value is an IP address.
 *
 * @param value
 * @return
 */
const ipAddressValidator = value => {

    if (_.isEmpty(value)) {
        return true;
    }

    let ipAdxCollection = value.split('.');
    if (ipAdxCollection.length !== 4) return false;

    let nonEmptyOctets = ipAdxCollection.filter(octet => !_.isEmpty(octet));
    let numberOctets = nonEmptyOctets.map(octet => _.toNumber(octet));
    let validOctets = numberOctets.filter(octet => octet >= 0 && octet < 256);

    return validOctets.length === 4;
};

export default validationRules;
